import { sortBy, filter } from 'lodash';
import {
  APP_DATA_LOADED,
  USER_LOGOUT,
  LOAD_SELECTED_AFFILIATE,
  API_LOADED_AFFILIATES,
  AFFILIATE_PRESELECTED,
  AFFILIATE_PRESELECTED_INCORRECT,
  RESET_AFFILIATE,
  API_LOADED_STAFFLIST,
} from '../types';

const defaultState = {
  affiliates: {
    // data: null,
    staffList: [],
    selectedAffiliateInfo: null,
    loaded: false,
    selected: false,
    dataLoaded: false,
  },
};

const getFullName = user =>
  filter([user.first_name, user.last_name]).join(' ');

const affiliate = (state = defaultState.affiliates, action) => {
  switch (action.type) {
    case AFFILIATE_PRESELECTED:
      return Object.assign({}, state, {
        selected: true,
      });

    case AFFILIATE_PRESELECTED_INCORRECT:
      return Object.assign({}, state, {
        selected: false,
      });

    case API_LOADED_AFFILIATES:
      return Object.assign({}, state, {
        loaded: true,
      });

    case APP_DATA_LOADED:
      return Object.assign({}, state, {
        dataLoaded: action.payload.dataLoaded,
      });

    case LOAD_SELECTED_AFFILIATE:
      return Object.assign({}, state, {
        selectedAffiliateInfo: action.payload,
      });

    case API_LOADED_STAFFLIST:
      return Object.assign({}, state, {
        staffList: sortBy(action.staffList, staff => getFullName(staff).toLowerCase()),
      });

    case RESET_AFFILIATE:
      return Object.assign({}, defaultState.affiliates, {
        loaded: true,
      });

    case USER_LOGOUT:
      return Object.assign({}, defaultState.affiliates);

    default:
      return state;
  }
};

export default affiliate;



// WEBPACK FOOTER //
// ./src/state/reducers/affiliates.js